import { render, staticRenderFns } from "./Masalah.vue?vue&type=template&id=e13ea558&scoped=true"
import script from "./Masalah.vue?vue&type=script&lang=js"
export * from "./Masalah.vue?vue&type=script&lang=js"
import style0 from "./Masalah.vue?vue&type=style&index=0&id=e13ea558&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e13ea558",
  null
  
)

export default component.exports